import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/fonts/[font]/components/Tabs/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/fonts/[font]/components/Title/style.module.css");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/node_modules/next/dist/client/link.js");
